import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

import { LinkHeroDtoSchema } from '../common/LinkHeroDto'

export const HeroDtoSchema = z.strictObject({
  imageUrl: StringDtoSchema.url(),
  heading: StringDtoSchema,
  subHeading: StringDtoSchema.nullable(),
  ingress: StringDtoSchema,
  cta1Copy: StringDtoSchema.nullable(),
  cta1Link: LinkHeroDtoSchema.nullable(),
  cta2Copy: StringDtoSchema.nullable(),
  cta2Link: LinkHeroDtoSchema.nullable(),
})

export type HeroDto = z.infer<typeof HeroDtoSchema>
